import { ContentSection, PreviewLinks, SelectDirections, Directions, Hero, Anchors, Appointment, Questions } from '@/components';
import SeoServiceLinks from '@/components/SeoServiceLinks';
import { StyledContent, StyledButton, StyledSection } from '@/components/styles';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import calcCurrentDirection from '@/lib/calcCurrentDirection';
import generateBlocks from '@/lib/generateBlocks';
import genLinkParams from '@/lib/generateLinkParams';
import { useTranslation } from 'react-i18next';

const AppointmentView = (props) => {
  const { t } = useTranslation('global');
  return (
    <StyledButton style={{ width: '100%' }} size="mid" light arrow {...props}>
      {t('bookAppointment')}
    </StyledButton>
  );
};

export default function DirectionServicesView({
  banners,
  directions,
  short_content,
  services = [],
  current_direction,
  blocks = [],
  questions = [],
  activeSlug,
  all_services,
  isServicesIndex = false,
}) {
  const { t } = useTranslation('global');
  const router = useRouter();

  const resolvedActiveSlug = isServicesIndex ? activeSlug : router.query.typeSlug || activeSlug;

  const defaultDirection = directions?.[0];
  const cur = useMemo(
    () => calcCurrentDirection(resolvedActiveSlug, directions || [], defaultDirection),
    [resolvedActiveSlug, directions, defaultDirection]
  );

  // На странице направления (URL = parent) breadcrumbs/title — от направления,
  // даже если услуги загружены по первому поднаправлению.
  const activeSubdirection = useMemo(() => {
    if (!resolvedActiveSlug || resolvedActiveSlug === cur?.slug) {
      return null;
    }

    return (
      cur?.children?.find((item) => item.slug === resolvedActiveSlug) ||
      (current_direction?.slug === resolvedActiveSlug ? current_direction : null) ||
      null
    );
  }, [resolvedActiveSlug, cur, current_direction]);

  const handleClick = (slug) => {
    if (!slug) return;
    const [, as] = genLinkParams({ type: 'subdirection', slug });
    router.push({ pathname: '/[typeSlug]', query: { typeSlug: slug } }, as);
  };

  const breadcrumbs = useMemo(() => {
    const base = [
      {
        id: 1,
        title: t('main.titlePage'),
        slug: '',
        type: 'index',
      },
      {
        id: 2,
        title: 'OUR SERVICES',
        slug: '',
        type: 'services',
      },
    ];

    if (isServicesIndex) {
      return base;
    }

    const items = [
      ...base,
      {
        id: 3,
        title: cur?.h1 || cur?.title || '',
        link: `/${cur?.slug}`,
        slug: cur?.slug || '',
        type: 'direction',
      },
    ];

    if (activeSubdirection) {
      items.push({
        id: 4,
        title: activeSubdirection?.h1 || activeSubdirection.title || '',
        link: `/${activeSubdirection.slug}`,
        slug: activeSubdirection.slug || '',
        type: 'subdirection',
      });
    }

    return items;
  }, [isServicesIndex, t, cur, activeSubdirection]);

  const heroBanners = useMemo(() => {
    if (!banners?.length || isServicesIndex) {
      return banners;
    }

    const title = activeSubdirection?.h1 || activeSubdirection?.title || cur?.h1 || cur?.title;
    console.log(title)
    console.log(activeSubdirection)
    console.log(cur)
    if (!title) {
      return banners;
    }

    return banners.map((banner) => ({ ...banner, title }));
  }, [banners, isServicesIndex, activeSubdirection, cur]);

  const selectActive = current_direction || activeSubdirection;

  return (
    <>
      {isServicesIndex && <SeoServiceLinks groups={all_services} />}
      {!!heroBanners?.length && (
        <Hero data={heroBanners} center={true} size="mid" breadcrumbs={breadcrumbs} asH1 />
      )}
      <StyledContent>
        <div style={{ overflow: 'hidden' }}>
          <StyledContent.Container hiddenMobile={isServicesIndex}>
            {!!directions?.length && <Directions directions={directions} active={cur} asLinks center />}
          </StyledContent.Container>
          {isServicesIndex && (
            <StyledContent.Container hiddenDesktop visibleMobile>
              {!!directions?.length && <PreviewLinks data={directions} items linksType="directions" />}
            </StyledContent.Container>
          )}
        </div>
        <StyledContent.Container hiddenMobile={isServicesIndex}>
          <StyledContent.Columns>
            <div>
              <StyledContent.Side>
                {!!cur?.children?.length && (selectActive || cur.children[0]) && (
                  <StyledContent.Select>
                    <SelectDirections
                      directions={cur.children}
                      active={selectActive || cur.children[0]}
                      onChange={handleClick}
                      scrollTop
                    />
                  </StyledContent.Select>
                )}
                {!!cur?.children?.length && (
                  <Anchors
                    list={cur.children}
                    active={selectActive?.slug || cur.children[0]?.slug}
                    asPageLinks
                  />
                )}
                <div style={{ marginTop: '20px' }} className="button-wrap">
                  <Appointment render={AppointmentView} />
                </div>
              </StyledContent.Side>
            </div>
            <StyledContent.ColumnMain>
              {!!services?.length && (
                <ContentSection noTitle>
                  <PreviewLinks data={services} items={3} />
                </ContentSection>
              )}
              {!isServicesIndex && !!blocks?.length && generateBlocks(blocks)}
              {!isServicesIndex && questions && questions.length > 0 && (
                <ContentSection pt="none" type="questions">
                  <Questions data={questions} />
                </ContentSection>
              )}
            </StyledContent.ColumnMain>
          </StyledContent.Columns>
        </StyledContent.Container>
        <StyledContent.Container>
          {short_content && (
            <StyledSection pt="none" pb="large">
              <StyledContent.Description>
                <StyledContent.Html dangerouslySetInnerHTML={{ __html: short_content }} dark />
              </StyledContent.Description>
            </StyledSection>
          )}
          <div></div>
        </StyledContent.Container>
      </StyledContent>
    </>
  );
}
